export const FORMAS_DE_PAGO: Record<FormasDePago, FormasDePago> = {
  MP: "MP",
  transferencia: "transferencia",
} as const;
